import { createContext, useContext } from 'react';

export const FeatureFlagsContext = createContext<Record<string, boolean>>(null);

export const useFeatureFlagContext = () => {
  const context = useContext(FeatureFlagsContext);
  if (context === undefined) {
    throw new Error('useFeatureFlagContext must be used within an AuthProvider');
  }
  return context;
};
